import React from "react";
import { motion } from "framer-motion";

const CHAPTERS = [
  { no: "01", title: "Global Sourcing & Quality Audit", body: "We hand-pick verified Indian suppliers and audit every batch for export-grade quality before it moves." },
  { no: "02", title: "Multimodal Routing Optimisation", body: "Sea, air or road — our routing engine selects the fastest, most cost-efficient path for your cargo." },
  { no: "03", title: "Customs & Compliance Mastery", body: "Documentation, HS codes, incoterms and duty optimisation handled end-to-end, with zero surprises." },
  { no: "04", title: "Door-to-Door Delivery Guarantee", body: "Real-time visibility from the Indian warehouse to your destination — 99.8% on-time delivery." },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <div className="mb-14 max-w-2xl">
        <span className="data-label">04 — The Suryavansh Method</span>
        <h2 className="mt-3 font-display text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl lg:text-5xl">
          Four chapters between<br />your cargo & the world.
        </h2>
      </div>

      <div className="flex flex-col">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.no}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`manifesto-chapter-${c.no}`}
            className="group grid grid-cols-1 gap-4 border-t border-white/10 py-8 transition-colors duration-500 hover:bg-white/[0.02] md:grid-cols-[140px_1fr_1.2fr] md:items-center md:gap-8"
          >
            <span className="font-mono-t text-4xl font-bold text-[#E65100] transition-transform duration-500 group-hover:translate-x-2 sm:text-5xl">{c.no}</span>
            <h3 className="font-display text-xl font-bold text-white sm:text-2xl">{c.title}</h3>
            <p className="text-sm text-slate-400 sm:text-base">{c.body}</p>
          </motion.div>
        ))}
        <div className="border-t border-white/10" />
      </div>
    </section>
  );
}
